<template>
  <section>
    <el-row class="selectRow">
      <el-col >
        <el-row :gutter="10">
					<el-button size="medium" type="primary" @click="addProduct">新增</el-button>
		      <el-button size="medium" type="success" @click="changeStatus(false,1)">启用</el-button>
		      <el-button size="medium" type="danger" @click="changeStatus(false,0)">禁用</el-button>
          <el-input
            @clear="getList"
            @keyup.enter.native="getList"
            ref="input"
            class="search  xs24"
            v-model="pdata.kw"
            clearable
            placeholder="请输入组合名称"
            :suffix-icon="pdata.kw.length>0?'':'el-icon-search'"
          ></el-input>
        </el-row>
      </el-col>
    </el-row>

    <!--列表-->
    

    <el-table
      :data="plist"
      style="width: 100%;min-width:1200px"
      class="groupTable"
      stripe
      row-key="id"
      @selection-change="select"
    >
      <el-table-column type="selection"></el-table-column>
      <!-- <el-table-column prop="id" label="ID" width="50px" align="center"></el-table-column> -->
      <el-table-column prop="name" label="组合名称" align="left">
      	 <template slot-scope="scope">
      	 			<div v-if="scope.row.isAdd==true">
      	 				 <el-input  v-model="plist[scope.$index].name" clearable placeholder="请输入组合名称"></el-input>
      	 			</div>
      	 			<div v-else>
      	 				<el-button type="text"  @click="$router.push({name:'创意组合详情',params:{index_id:scope.row.id}})"  >{{scope.row.name}}</el-button>
      	 			</div>
						  
        </template>
      </el-table-column>
      <el-table-column prop="product_num" label="产品个数" align="center">
      	<template slot-scope="scope">
      				<div v-if="scope.row.isAdd==true"></div>
						  <div v-else><span>{{scope.row.product_num.ok}}/{{scope.row.product_num.count}}</span></div>
        </template>
      </el-table-column>
      
      <el-table-column prop="create_time" label="创建时间" align="center">
      		<template slot-scope="scope">
      			<div v-if="scope.row.isAdd==true"></div>
      			<div v-else><span>{{scope.row.create_time}}</span></div>
      	 </template>
      </el-table-column>

      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
        	<div v-if="scope.row.isAdd==true">
        		 <el-button size="mini" type="primary" @click="saveProduct(scope.$index)">保存</el-button>
        	</div>
          <div v-else>
	          	<el-button
	            size="mini"
	            :type="scope.row.status=='1'?'success':'danger'"
	            @click="changeStatus(true,scope.row)"
	          >{{scope.row.status=='1'?'正常':'禁用'}}</el-button>
	          <el-button size="mini" type="primary" @click="searchOne(scope)">编辑</el-button>
	          <el-button size="mini" type="text" @click="openDealy(scope.row.id)">更新日志</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pageRow">

    <el-pagination
      class="pagination"
      @size-change="SizeChange"
      @current-change="CurrentChange"
      :current-page.sync="pdata.page"
      :page-sizes="[20, 40, 60, 80]"
      :page-size="pdata.perpage"
      background
      layout="sizes, prev, pager, next, jumper"
      :total="pdata.perpage*maxPage"
    ></el-pagination>
    </div>
  </section>
</template>

<script>
import { sglist, saddg, sgone, sgstatus, seditg ,sclog,baseUrl,selectCreative } from "../../api/api";
export default {

  data() {
    return {
      rules: {
        name: [
          { required: true, message: "请输入创意组合名称", trigger: "change" }
        ],
        creative_ids: [
          { required: true, message: "请选择创意", trigger: "blur" }
        ]
      },
      pdata: {
        page: 1,
        perpage: 20,
        status: "",
        kw: "",
        sort_field: "",
        sort_by: ""
      },
      plist: [],
      maxPage: 1,
      config: [],
    
   
      chooseProduct: {},
      formLabelWidth: "120px",
      cP: {
        index_id: "",
        status: "1",
        log: ""
      }, //修改选中的产品状态,批量修改状态
      isAdd: true,
    };
  },
  //   created() {
  //   let that = this;
  //   document.onkeypress = function(e) {
  //     var keycode = document.all ? event.keyCode : e.which;
  //     if (keycode == 13&&that.editDialog) {
  //       that.submit();
  //        return false;
  //     }
  //   };
  // },
  watch: {
  	"pdata.kw":{
  		 handler(n, o) {
    		this.getList();
      },
      deep: true
  	},
    "glist.length": {
      handler(n, o) {
        var p = "0";
        this.glist.forEach((v, i) => {
          p += "," + v.id;
        });
        this.form.creative_ids = p.slice(2);
      },
      deep: true
      // immediate: true
    }
  },
  methods: {
  	  openDealy(id) {
  	 	var p = 'type=creativebale&index_id='+id;
      sclog(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.logDialog = true;
          this.plog = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getList() {
      var p = "";
      for (var k in this.pdata) {
        // if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      sglist(p, this.$cookie.getCookie("login")).then(res => {
      
        if (res.code == 200) {
        	if(res.data.list&&res.data.list.length>0){
        			res.data.list.forEach((v,i)=>{
			      		v.isAdd=false;
			      	})
        			this.plist = res.data.list;
          		this.maxPage = res.data.max_page;
        	}
        	else{
	    		  this.plist = [];
	      		this.maxPage = 1;
        	}
        
        }
      });
    },
    getConfig() {
      if (this.$store.config) {
        this.config = this.$store.config.ad_creative_type;
        this.tags = this.$store.config.product_tag;
      } else {
        setTimeout(() => {
          this.getConfig();
        }, 50);
      }
    },
    statueFilter(s) {
      this.sText = s == "" ? "请创意状态" : s == "0" ? "禁用" : "启用";
      this.pdata.status = s;
      this.getList();
    },
    select(s) {
      this.selectProduct=s;
      var p = "测";
      s.forEach((v, i) => {
        p += "," + v.id;
      });
      this.cP.index_id = p.slice(2);
    },
    SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    themeFilter(s) {
      this.tText = s == "" ? "请选择创意类型" : s;
      this.pdata.type = s;
      // this.getList();
    },
    changeStatus(isSingle, s) {
 
     
		      if (!isSingle && this.selectProduct.length == 0) {
		        this.$message.error("请先选择需要批量操作的数据");
		        return;
		      }
		      if (isSingle) {
		        this.cP.index_id = s.id;
		        this.cP.status = s.status == 1 ? "0" : "1";
		      } else {
		        this.cP.status = s;
		      }
		//    if (this.cP.status == 0) {
		//      this.cP.log = "禁用产品";
		//    } else if (this.cP.status == 1) {
		//      this.cP.log = "启用产品";
		//    } else if (this.cP.status == -1) {
		//      this.cP.log = "删除产品";
		//    }
				 this.$confirm(this.cP.status==1?'启用需二次确认, 是否继续?':'禁用需二次确认, 是否继续?', '提示', {
	          confirmButtonText: '确定',
	          cancelButtonText: '取消',
	          type: 'warning'
	        }).then(() => {
		        sgstatus(this.cP, this.$cookie.getCookie("login")).then(res => {
		          if (res.code == 200) {
		            this.getList();
		            this.$message({ message: this.cP.log+"成功", type: "success" });
		          }
		        });

      });
    
      
    },
    addProduct() {
      if(this.plist[0].isAdd){
    		this.$message.error('请先保存再增加更多');
    		return false;
    	}
      this.isAdd=true;
    	this.plist.unshift({name:"",create_time: "",update_time: "",product_num: {count: "0", ok: "0"},isAdd:true});
    },

		saveProduct(index){
			if(this.plist[index].name==''){
    		this.$message.error('创意组合名称不能为空');
    		return false;
    	}
			if (this.isAdd) {
            saddg({ "name": this.plist[index].name}, this.$cookie.getCookie("login")).then(res => {
              if (res.code == 200) {
                  this.$message({ message: "新增创意组合成功", type: "success" });
	                this.getList();
                // this.group={};
              } else {
                this.$message.error(res.msg);
              }
            });
      } else {
              seditg({"index_id":this.plist[index].id,"name":this.plist[index].name}, this.$cookie.getCookie("login")).then(res => {
                if (res.code == 200) {
                  this.$message({ message: "编辑创意组合成功", type: "success" });
                  this.getList();
           

                  
                } else {
                  this.$message.error(res.msg);
                }
              });
          
      }
		},
    searchOne(s) {
    	this.plist[s.$index]=s.row;
    	this.plist[s.$index].isAdd=true;
    	 this.isAdd=false;
    	this.$forceUpdate();
    	
      
    },
  


  },

  mounted() {
    this.getList();
    this.getConfig();
  }
};
</script>

<style scoped lang="scss">
.gImg {
  width: 60px;
  height: 60px;
  margin-right: 10px;
  border-radius: 8px;
}



</style>

<style scoped>
.groupTable .el-table__expand-column .el-table__expand-icon {
  display: none;
  width: 0px;
} 
.groupTable .el-table__expanded-cell[class*="cell"] {
  padding: 10px 50px;
}
.myDialog .el-dialog {
  width: 500px;
  margin: 0 auto;
}

</style>

<style>
	.badge .el-badge__content{
		transform: translateY(0%) translateX(200%) ;
	}
</style>




// WEBPACK FOOTER //
// CreativeGroupList.vue?5ef7c22d